import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer, ProviderToken } from '@angular/core';
import { GenericFeatureFlagService, GenericFeatureFlagUserIdentificationService } from '@rma/generic/ng/feature-flags/internal';
import { LAUNCH_DARKLY_CLIENT_ID } from './domain/launch-darkly-client-id.token';
import { FeatureFlagsBrowserService } from './util-feature-flag-service/feature-flag.browser.service';

function initialiseLaunchDarkly(launchDarklyService: GenericFeatureFlagService): () => Promise<void> {
  return () => launchDarklyService.load();
}

function initialiseUserIdentification(featureUserService: GenericFeatureFlagUserIdentificationService) {
  return () => featureUserService.initialise();
}

export function provideRmaFeatureFlagsBrowser(
  clientId: string,
  userIdToken?: ProviderToken<GenericFeatureFlagUserIdentificationService>,
): EnvironmentProviders {
  const providers = [
    {
      provide: LAUNCH_DARKLY_CLIENT_ID,
      useValue: clientId,
    },
    {
      provide: GenericFeatureFlagService,
      useClass: FeatureFlagsBrowserService,
    },
    provideAppInitializer(() => {
      const initializerFn = initialiseLaunchDarkly(inject(GenericFeatureFlagService));
      return initializerFn();
    }),
  ];

  if (userIdToken) {
    providers.push(
      provideAppInitializer(() => {
        const initializerFn = initialiseUserIdentification(inject(userIdToken));
        return initializerFn();
      }),
    );
  }

  return makeEnvironmentProviders(providers);
}
